/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dictation_StartInputs */

const en_dictation_start = /** @type {(inputs: Dictation_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dictate`)
};

const pt_br2_dictation_start = /** @type {(inputs: Dictation_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditar`)
};

/**
* | output |
* | --- |
* | "Dictate" |
*
* @param {Dictation_StartInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dictation_start = /** @type {((inputs?: Dictation_StartInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictation_StartInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dictation_start(inputs)
	return pt_br2_dictation_start(inputs)
});